var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBatteryPack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 14.5029V13.0417H30.75V9.54169H29V8.08044C29 7.44169 28.475 6.91669 27.8363 6.91669L14.4225 6.91669C13.775 6.91669 13.25 7.44169 13.25 8.08044V14.4942C13.25 15.1417 13.775 15.6667 14.4137 15.6667L27.8363 15.6667C28.475 15.6667 29 15.1417 29 14.5029Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 24.7113V23.25H30.75V19.75H29V18.2887C29 17.65 28.475 17.125 27.8363 17.125H14.4225C13.775 17.125 13.25 17.65 13.25 18.2887V24.7025C13.25 25.35 13.775 25.875 14.4137 25.875H27.8363C28.475 25.875 29 25.35 29 24.7113Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 34.9196V33.4584H30.75V29.9584H29V28.4971C29 27.8584 28.475 27.3334 27.8363 27.3334H14.4225C13.775 27.3334 13.25 27.8584 13.25 28.4971V34.9109C13.25 35.5584 13.775 36.0834 14.4137 36.0834H27.8363C28.475 36.0834 29 35.5584 29 34.9196Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryPack);
export default __webpack_public_path__ + "static/media/battery-pack.444a0c19001c9d2ff919f7e944effdf6.svg";
export { ForwardRef as ReactComponent };